import React, { FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { EditEntries } from '../../entries/edit-entries';
import { CreateOrganization, Organization, Throughput } from '../../../../types';
import { L } from 'harmony-language';

interface ThroughputSettingsProps {
    organization: CreateOrganization | Organization;
    onChange: (t: Throughput[]) => void;
}

export const ThroughputSettings: FC<ThroughputSettingsProps> = (props) => {
    const { organization, onChange } = props;

    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
            >
                {L.throughputSettings()}
            </AccordionSummary>
            <AccordionDetails>
                <EditEntries
                    throughputs={organization.throughputs}
                    cargoTypes={organization.cargoTypes}
                    onChange={onChange}
                />
            </AccordionDetails>
        </Accordion>
    );
};
